import { Typography } from "@mui/material";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import DuomenysKraunami from "../shared/DuomenysKraunami";
import { isAllDataNull } from "../../functions/produktyvumas/grafikuReziai";
import useBreakpoints from "../../styles/windowSizes";
import { MultiColorMix } from "../../constants/Spalvos";
import DuomenuNera from "../shared/DuomenuNera";
import { useEffect, useState } from "react";

/**
 * Diagramos su daug stulpeliu komponentas
 * @param {string} pavadinimas diagramos pavadinimas
 * @param {boolean} isLoading ar kraunami duomenys, jei taip returns {DuomenysKraunami} komponentas
 * @param {Object} data transformuoti duomenys, objektas su masyvu raktu
 * @param {string} raktoDuomenys raktas nurodantis, kurį masyvą naudoti raktų ištraukimui
 * @returns
 */
const DaugStulpeliuGrafikas = ({
  pavadinimas,
  isLoading,
  chartData,
  yAxisMin,
  yAxisMax,
  raktai,
  xAsis,
  neraDuomenenuTekstas,
  minHeight = "280px",
  position = "insideBottom", // "inside", "outside", "insideRight", "insideTop", "insideStart", "insideEnd", "end", "center"
  angle = 90,
  stulpeliaiSuEtiketemis = null,
}) => {
  const { isSm, isMd, isLg, isXl } = useBreakpoints();
  const [reikiaEtiketes, setReikiaEtiketes] = useState(true);

  useEffect(() => {
    const updateLegendPosition = () => {
      if (window.innerWidth < 1400 || window.innerWidth < 1650) {
        setReikiaEtiketes(false);
      } else {
        setReikiaEtiketes(true);
      }
    };

    updateLegendPosition(); // pradine busena
    window.addEventListener("resize", updateLegendPosition);

    return () => window.removeEventListener("resize", updateLegendPosition);
  }, []);

  if (isLoading) return <DuomenysKraunami pavadinimas={pavadinimas} />;

  const isDataAvailable = isAllDataNull(chartData, xAsis);

  if (isDataAvailable) {
    return <DuomenuNera pavadinimas={pavadinimas} pranesimas={neraDuomenenuTekstas} />;
  }

  // const colors = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#0088fe", "#00C49F", "#FFBB28"];

  return (
    <>
      <Typography>{pavadinimas}</Typography>
      <ResponsiveContainer width="100%" height="100%" minHeight={minHeight}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xAsis} />
          <YAxis domain={[yAxisMin, yAxisMax]} />
          <Tooltip />
          <Legend />
          {raktai.map((key, index) => (
            <Bar
              key={key}
              barSize={isXl ? 24 : isLg ? 30 : isMd ? 20 : isSm ? 15 : 10}
              dataKey={key}
              fill={MultiColorMix[index]}
              name={key}
            >
              {reikiaEtiketes && stulpeliaiSuEtiketemis && stulpeliaiSuEtiketemis.includes(key) && (
                <LabelList
                  dataKey={key}
                  position={position}
                  offset={33}
                  fill="black"
                  angle={angle}
                  textAnchor="middle"
                  dominantBaseline="middle"
                />
              )}
            </Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default DaugStulpeliuGrafikas;
